import classnames from 'classnames/bind'
// Components
import Icon from '@/assets/icons'

// Styles
import styles from './style.module.scss'

// Variables
const cx = classnames.bind(styles)

// PropTypes
type propTypes = {
  title?: string
  onClick?: () => void
  className?: string
  theme?: 'black' | 'white'
}

const BackToProfile = (props: propTypes) => {
  const { title, onClick, className, theme = 'black' } = props
  return (
    <div
      onClick={(event) => {
        event.stopPropagation()
        onClick && onClick()
      }}
      className={cx('back', className)}
    >
      <div className={cx('back-icon')} data-theme={theme}>
        <Icon.ArrowLeft />
      </div>
      <div className={cx('back-text')}>{title}</div>
    </div>
  )
}

export default BackToProfile
